import { render, staticRenderFns } from "./NewArrivals.vue?vue&type=template&id=d2f8901a&scoped=true&"
import script from "./NewArrivals.vue?vue&type=script&lang=js&"
export * from "./NewArrivals.vue?vue&type=script&lang=js&"
import style0 from "./NewArrivals.vue?vue&type=style&index=0&id=d2f8901a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f8901a",
  null
  
)

export default component.exports